import { useMemo } from 'react';

type VariableKeyName =
  | 'newIndexData'
  | 'smartbannerJSON'
  | 'staticResourceCDNDomain'
  | 'lastModify'
  | 'holaRevisionProductData'
  | 'newCategoryData'
  | 'searchPageData'
  | 'serverIP'
  | 'adPageData'
  | 'productData'
  | 'pageData'
  | 'SEOdescription';

export function usePageData<T = unknown>(key: VariableKeyName): T | null {
  const data = useMemo(() => {
    return window[key as keyof typeof window] as T | null;
  }, [key]);

  return data;
}

export function usePageConstant<T>(key: string): T | null {
  const constant = useMemo(() => {
    return window[key as keyof typeof window] as T | null;
  }, [key]);

  return constant;
}
